/*Global*/
import logo from '../assets/Logo/Logo.png';


/*Home*/
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';


/*About*/
import about from '../assets/About/About.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Process*/ 
import step1 from '../assets/Process/Step-1.jpg';
import step2 from '../assets/Process/Step-2.jpg';
import step3 from '../assets/Process/Step-3.jpg';
import step4 from '../assets/Process/Step-4.jpg';
import step5 from '../assets/Process/Step-5.jpg';
import step6 from '../assets/Process/Step-6.jpg';


/*Careers*/
import careerIntro1 from '../assets/Career/Intro/Career-1.jpg';
import careerIntro2 from '../assets/Career/Intro/Career-2.jpg';
import careerIntro3 from '../assets/Career/Intro/Career-3.jpg';
import position1 from '../assets/Career/Positions/Position-1.jpg';
import position2 from '../assets/Career/Positions/Position-2.jpg';
import position3 from '../assets/Career/Positions/Position-3.jpg';
import position4 from '../assets/Career/Positions/Position-4.jpg';
import position5 from '../assets/Career/Positions/Position-5.jpg';
import position6 from '../assets/Career/Positions/Position-6.jpg';


/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';
import partner7 from '../assets/Partners/Partner-7.png';
import partner8 from '../assets/Partners/Partner-8.png';


/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*Projects*/
import project1 from '../assets/Project/Projects/Project-1.jpg';
import project1Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project1Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project1Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project1Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project1Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project1Gallery6 from '../assets/Project/Project-Gallery/6.jpg';

import project2 from '../assets/Project/Projects/Project-2.jpg';
import project2Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project2Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project2Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project2Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project2Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project2Gallery6 from '../assets/Project/Project-Gallery/6.jpg';

import project3 from '../assets/Project/Projects/Project-3.jpg';
import project3Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project3Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project3Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project3Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project3Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project3Gallery6 from '../assets/Project/Project-Gallery/6.jpg';

import project4 from '../assets/Project/Projects/Project-4.jpg';
import project4Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project4Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project4Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project4Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project4Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project4Gallery6 from '../assets/Project/Project-Gallery/6.jpg';

import project5 from '../assets/Project/Projects/Project-5.jpg';
import project5Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project5Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project5Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project5Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project5Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project5Gallery6 from '../assets/Project/Project-Gallery/6.jpg';

import project6 from '../assets/Project/Projects/Project-6.jpg';
import project6Gallery1 from '../assets/Project/Project-Gallery/1.jpg';
import project6Gallery2 from '../assets/Project/Project-Gallery/2.jpg';
import project6Gallery3 from '../assets/Project/Project-Gallery/3.jpg';
import project6Gallery4 from '../assets/Project/Project-Gallery/4.jpg';
import project6Gallery5 from '../assets/Project/Project-Gallery/5.jpg';
import project6Gallery6 from '../assets/Project/Project-Gallery/6.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/11.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,

    /*About*/
    about,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Process*/
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Career Introduction*/
    careerIntro1,
    careerIntro2,
    careerIntro3,

    /*Positions*/
    position1,
    position2,
    position3,
    position4,
    position5,
    position6,

    /*Services*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Projects*/
    project1,
    project1Gallery1,
    project1Gallery2,
    project1Gallery3,
    project1Gallery4,
    project1Gallery5,
    project1Gallery6,

    project2,
    project2Gallery1,
    project2Gallery2,
    project2Gallery3,
    project2Gallery4,
    project2Gallery5,
    project2Gallery6,

    project3,
    project3Gallery1,
    project3Gallery2,
    project3Gallery3,
    project3Gallery4,
    project3Gallery5,
    project3Gallery6,

    project4,
    project4Gallery1,
    project4Gallery2,
    project4Gallery3,
    project4Gallery4,
    project4Gallery5,
    project4Gallery6,

    project5,
    project5Gallery1,
    project5Gallery2,
    project5Gallery3,
    project5Gallery4,
    project5Gallery5,
    project5Gallery6,

    project6,
    project6Gallery1,
    project6Gallery2,
    project6Gallery3,
    project6Gallery4,
    project6Gallery5,
    project6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,


    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

};

export default images;